<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>成功了！空間恢復正常了！</npc>
              <npc :npc-id="0">不只如此，你看，石獅口中還有下一份提示。</npc>

              <story-image :src="require(`@/assets/images/pics/第2章_1-1_南山寺紙條.jpg`)"></story-image>
              <!-- （圖片：提示紙條） -->

              <npc :npc-id="0">『恭喜你，呂善安君。但要奪回賴和的歷史，你要更努力；接下來，請到臺灣文化協會平常演講的地方。』</npc>
              <npc :npc-id="1" right>咦？他說的是林獻堂、蔣渭水他們成立的臺灣文化協會？</npc>
              <npc :npc-id="0">應該是。雖然表面上是文化組織，但臺灣文化協會跟臺灣的社會運動有盤根錯節的關係，賴和先生最初也是理事之一。</npc>
              <npc :npc-id="1" right>那臺灣文化協會平常是在哪裡演講？</npc>
              <npc :npc-id="0">臺灣文化協會的演講大多會選擇在公眾場域，其中公會堂有可能是一個選項。公會堂也就是現在的彰化藝術館，離這裡沒有多遠。</npc>
              <npc :npc-id="1" right>那就快走吧！說不定怪盜還在那裡——</npc>
              <npc :npc-id="0">等一下，我想先聯絡臺灣文學館。</npc>
              <npc :npc-id="1" right>嗯？為什麼？</npc>
              <npc :npc-id="0">為何怪盜會知道我的存在，刻意留言給我？我覺得不可思議。會不會是文學館內部有人通風報信？我想確認這件事。</npc>
              <npc :npc-id="1" right>通風報信？不會吧！</npc>
              <npc :npc-id="0">我也不希望啊，總之先聯絡看看⋯⋯咦？奇怪了。</npc>
              <npc :npc-id="1" right>怎麼了？</npc>
              <npc :npc-id="0">是空號。</npc>
              <npc :npc-id="1" right>空號？怎麼可能，是你打錯了吧！</npc>
              <npc :npc-id="0">我是用通訊錄，不可能啊？糟了，我有不好的預感。</npc>

              <p class="text-center py-5">(呂善安用手機連上網路調查。)</p>

              <npc :npc-id="1" right>喂，呂善安，怎麼回事？你臉色好糟喔！</npc>
              <npc :npc-id="0">糟了，臺灣文學館不見了。</npc>
              <npc :npc-id="1" right>不見了？怎麼回事？難道也被偷走了！？</npc>
              <npc :npc-id="0">不，是『臺灣文學館』這個機構消失了；我剛剛用網路查過，不在文化部底下，臺南州廳也變成我們不知道的館舍⋯⋯我唯一想到的可能，就是歷史被改變了，在這個世界，並沒有『臺灣文學館』，甚至可能沒有鮮明的臺灣文學的想像！</npc>
              <npc :npc-id="1" right>——不會吧？怎麼可能？</npc>
              <npc :npc-id="0">是怪盜幹的。</npc>
              <npc :npc-id="1" right>怪盜能做到這種事？</npc>
              <npc :npc-id="0">其實我也沒證據，但怪盜能偷走時間，或許能對時間或歷史動什麼手腳！可惡，難道是趁我們恢復時空的時候做了什麼的？明明知道有陷阱，我卻這樣跳了進去⋯⋯</npc>
              <npc :npc-id="1" right>⋯⋯</npc>
              <npc :npc-id="0">⋯⋯</npc>
              <npc :npc-id="1" right>⋯⋯呂善安，你啊，到底在沮喪什麼？</npc>
              <npc :npc-id="0">我能不沮喪嗎？我可是臺灣文學偵探，結果不但沒有阻止這種事發生，還成了怪盜的共犯！</npc>
              <npc :npc-id="1" right>還不確定這是剛剛恢復時空造成的吧？</npc>
              <npc :npc-id="0">不確定，但要說完全無關實在太樂觀了。無論如何，我們現在所處的就是『沒有臺灣文學館』的時空。</npc>
              <npc :npc-id="1" right>這我當然知道。但那也沒什麼啊，不過就是要從怪盜手中奪回來的東西多了一個而已。</npc>
              <npc :npc-id="0">⋯⋯什麼？</npc>
              <npc :npc-id="1" right>不是這樣嗎？原本我們就在追捕怪盜。要是成功抓到怪盜，他一定知道怎麼恢復時空吧！所以現在根本不能浪費時間！</npc>
              <npc :npc-id="0">⋯⋯說的也是呢。</npc>
              <npc :npc-id="0">又不是毫無線索。怪盜都像這樣挑釁了，不抓到他可說不過去！謝啦，小蘇。</npc>
              <npc :npc-id="1" right>總算振作起來了。上吧！呂善安！</npc>
              <npc :npc-id="0">嗯！朝公會堂前進吧！</npc>

              <map-link name="彰化市公會堂" map-id="QDVpKceWGDq8Yu9w5"/>

              <move-to-stage-btn link="前往公會堂">前往公會堂</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage2_1',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第二章 - 1',
      isQuestion: false,
      stageId: 'next',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
